<template>
  <div class="overview-wrapper">
    <div class="overview-header">
      <h3>Cost Summary</h3>
    </div>

    <div class="quiz-answers">
      <ul>
        <li v-if="getCostInputed >= 2">
          <span class="answer-heading">Foundational Screening Package</span>
        </li>
        <li v-if="getCostInputed >= 2">
          <span
              style="text-transform: capitalize;color: var(--imc-primary-color);"
          >{{ `${getGender} ` }} {{ `${getAge}` }}</span>
          <span class="quiz-amount">${{ getFoundationalCost }}</span>
        </li>
        <li v-if="getCostInputed >= 2">
          <span class="answer-heading">Supplementary Screenings</span>
          <br />
        </li>
        <li v-for="(historyOpt, index) in history" :key="`historyOpt-${index}`">
          <span style="color: var(--imc-primary-color);">{{ historyOpt.key }}</span>
          <span class="remove" @click="removeHistory(historyOpt.indicator)"><img :src=" require(`../assets/icons/remove.png`) " style="width:16px;" /></span>
          <span class="quiz-amount" v-if="historyOpt.cost != 0">${{ historyOpt.cost }}</span>
        </li>
        <li v-for="(healthIssueOpt, index) in healthIssue" :key="`healthIssueOpt-${index}`">
          <span
              style="text-transform: capitalize;color: var(--imc-primary-color);"
          >{{ healthIssueOpt.key }}</span>
          <span class="remove" @click="removeHealthIssue(healthIssueOpt.indicator)"><img :src=" require(`../assets/icons/remove.png`) " style="width:16px;" /></span>
          <span class="quiz-amount" v-if="healthIssueOpt.cost != 0">${{ healthIssueOpt.cost }}</span>
        </li>
        <li v-for="(discussOpt, index) in discuss" :key="`discussOpt-${index}`">
          <span
              style="text-transform: capitalize;color: var(--imc-primary-color);"
          >{{ discussOpt.key }}</span>
          <span class="remove" @click="removeDiscuss(discussOpt.indicator)"><img :src=" require(`../assets/icons/remove.png`) " style="width:16px;" /></span>
          <span class="quiz-amount">${{ discussOpt.cost }}</span>
        </li>
        <li v-if="hasAnyOptions">
          <span class="answer-heading" style="text-transform: capitalize;">Supplementary Consultation Charge</span>
          <span class="quiz-amount">$85</span>
        </li>
        <li>
          Estimated costs (excluding GST)
          <span
              class="quiz-amount"
              style="color: var(--imc-primary-color);"
          >{{ totalAmount }}</span>
        </li>
      </ul>
      <p>The above is a guide price only and may change depending upon the tests and investigations advised by the Doctor, in consultation with you. Please note that you will always be advised of price changes before undertaking any tests.</p>
      <p>If you feel that these tests do not meet your needs, please discuss your requirements with your doctor during the consultation.</p>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import conPrice from "../data/conclusion-price.json";
import foundationData from "../data/foundational-data.json";

export default {
  name: "QuizOverview",

  data() {
    return {
      additionalInfo: ""
    };
  },

  computed: {
    ...mapGetters( [
      "getCompletedStep",
      "getGender",
      "getAge",
      "getHistory",
      "getHealthIssue",
      "getDiscuss",
      "getAdditionalInfo",
      "getCost",
      "getCostInputed"
    ] ),

    getFoundationalCost() {
      return foundationData[ this.getGender ][ this.getAge ].cost;
    },

    history() {
      let selected = [];
      Object.keys( this.getHistory ).forEach( key => {
        if ( this.getHistory[ key ].selected ) {
          selected.push( {
            key: this.getHistory[ key ].desc,
            cost: conPrice.history[ key ][ this.getGender ],
            indicator: key
          } );
        }
      } );
      return selected;
    },

    historyPrice() {
      let price = 0;
      Object.keys( this.getHistory ).forEach( key => {
        if ( this.getHistory[ key ].selected && key !== "none" ) {
          price += conPrice.history[ key ][ this.getGender ];
        }
      } );

      return price;
    },

    healthIssuePrice() {
      let price = 0;
      Object.keys( this.getHealthIssue ).forEach( key => {
        if ( this.getHealthIssue[ key ].selected && key !== "none" ) {
          price += conPrice.healthIssue[ key ][ this.getGender ];
        }
      } );
      return price;
    },

    discussPrice() {
      let price = 0;
      Object.keys( this.getDiscuss ).forEach( key => {
        if ( this.getDiscuss[ key ].selected && key !== "none" ) {
          price += conPrice.discuss[ key ][ this.getGender ];
        }
      } );
      return price;
    },

    healthIssue() {
      let selected = [];
      Object.keys( this.getHealthIssue ).forEach( key => {
        if ( this.getHealthIssue[ key ].selected ) {
          selected.push( {
            key: this.getHealthIssue[ key ].desc,
            cost: conPrice.healthIssue[ key ][ this.getGender ],
            indicator: key
          } );
        }
      } );
      return selected;
    },

    discuss() {
      let selected = [];
      Object.keys( this.getDiscuss ).forEach( key => {
        if ( this.getDiscuss[ key ].selected ) {
          selected.push( {
            key: this.getDiscuss[ key ].desc,
            cost: conPrice.discuss[ key ][ this.getGender ],
            indicator: key
          } );
        }
      } );
      return selected;
    },

    hasAnyOptions() {
      let selected = false;

      Object.keys( this.getHistory ).forEach( key => {
        if ( this.getHistory[ key ].selected && key !== "none" ) {
          selected = true;
        }
      } );

      Object.keys( this.getDiscuss ).forEach( key => {
        if ( this.getDiscuss[ key ].selected && key !== "none" ) {
          selected = true;
        }
      } );

      Object.keys( this.getHealthIssue ).forEach( key => {
        if ( this.getHealthIssue[ key ].selected && key !== "none" ) {
          selected = true;
        }
      } );

      return selected;
    },

    totalAmount() {
      let sum = 0;

      for ( let i = 0; i < this.getCompletedStep; i ++ ) {
        sum += this.getCost[ i ];
      }

      if ( this.getCostInputed >= 2 ) {
        sum += this.getFoundationalCost;
      }

      if ( this.getCostInputed >= 4 ) {
        sum += this.historyPrice;
      }

      if ( this.getCostInputed >= 5 ) {
        sum += this.healthIssuePrice;
      }

      if ( this.getCostInputed >= 6 ) {
        sum += this.discussPrice;

        if ( this.hasAnyOptions ) {
          sum += 0;
        }
      }

      if ( this.hasAnyOptions ) {
        sum += 85;
      }

      return `$${sum}`;
    }
  },

  methods: {
    ...mapMutations( ["setStep", "setHistory", "setHealthIssue", "setDiscuss"] ),

    removeHistory( key ) {
      let data = this.getHistory;
      data[ key ].selected = false;

      this.setHistory( data );
    },

    removeHealthIssue( key ) {
      let data = this.getHealthIssue;
      data[ key ].selected = false;

      this.setHealthIssue( data );
    },

    removeDiscuss( key ) {
      let data = this.getDiscuss;
      data[ key ].selected = false;

      this.setDiscuss( data );
    }
  }
};
</script>

<style scoped>
.quiz-amount {
  float: right;
}

.overview-wrapper {
  padding: 1.5rem;
  box-shadow: 0 5px 15px 0 rgba(0, 0, 0, 0.08);
  background: #fff;
}

ul,
li {
  list-style: none;
  padding: 0;
  margin: 0;
}

ul {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

ul li {
  position: relative;
  padding: 0.5rem 0;
  background-color: #fff;
  cursor: pointer;
  transition: all 0.15s ease-in-out;
  text-align: left;
  display: block;
  width: 100%;
}

ul li:first-child,
ul li span:first-child {
  display: inline-block;
}

.answer-heading {
  font-weight: bold;
}

ul li:last-child {
  font-weight: bold;
  font-size: 1.2rem;
  border-top: 1px solid #ddd;
}

ul li:last-child span {
  margin: 0;
}

.quiz-answers p {
  margin-top: 1.5rem;
  font-size: 0.8rem;
}

.remove img {
  margin-left: 0.5rem;
}
</style>
